import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "concourse-progress-modal",
  templateUrl: "./progress-modal.component.html",
  styleUrls: ["./progress-modal.component.scss"],
})
export class ProgressModalComponent implements OnInit {
  @Input() processing: any = 0;
  @Input() total: any = 0;
  @Input() approved: any = 0;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}
}
